import { put, call, takeLatest, select, all } from 'redux-saga/effects';
// import { getDistance } from 'geolib';

import {
	initiateFetchPods,
	fetchPodsSuccess,
	fetchPodsError,
	fetchPodBannerSuccess,
	fetchAffilateSuccess,
	selectPod,
} from '../actions/pods';
import { FETCH_PODS, FETCH_POD_BANNERS, FETCH_AFFILIATE } from '../actions/types';
import { getLivePods, getPodBanners, getAffiliateData } from '../services/pods';
// import { fetchLatlng } from '../utils';
import { showErrorMsg } from '../actions/snackbar';
import { validateSession } from './session';
import { EXPRESS_DELIVERY, MACHINE_PICKUP } from '../constants';

// const podDummyData = [
//   { IMEI: "TM02201908", name: "AltiSource_Terrace" },
//   { IMEI: "TM02201910", name: "Wipro_SJP2" }
// ];

function* fetchPods(action) {
	try {
		const { mobile } = action.payload || {};
		yield put(initiateFetchPods());
		const { sessionId } = yield select((state) => state.auth || {});
		const res = yield call(validateSession, getLivePods, mobile, {}, sessionId);
		let { selectedPod = null } = yield select((state) => state.pod || {});
		const { machines = [] } = res;
		const darkStores = [];
		const machinePickup = [];
		for (const machine of machines) {
			let { webapp_config } = machine;
			let bMachine = false;
			let bExpress = false;
			if (webapp_config) {
				webapp_config = JSON.parse(webapp_config);
				const { machine_pickup = 0, express_delivery = 0 } = webapp_config;
				if (express_delivery) {
					bExpress = true;
					darkStores.push({ ...machine, express: 1, locationType: EXPRESS_DELIVERY });
				}
				if (machine_pickup) {
					machinePickup.push({ ...machine, machine: 1, locationType: MACHINE_PICKUP });
					bMachine = true;
				}
			} else {
				machinePickup.push({ ...machine, machine: 1, locationType: MACHINE_PICKUP });
				bMachine = true;
			}

			if (selectedPod && selectedPod.vm_imei_id === machine.vm_imei_id) {
				const { locationType } = selectedPod;
				selectedPod = { ...machine };
				if (!locationType) {
					if (bExpress && !bMachine) {
						selectedPod = {
							...selectedPod,
							express: 1,
							locationType: EXPRESS_DELIVERY,
						};
					} else {
						selectedPod = {
							...selectedPod,
							machine: +bMachine,
							locationType: MACHINE_PICKUP,
						};
					}
				}
				if (locationType === EXPRESS_DELIVERY) {
					selectedPod = {
						...selectedPod,
						locationType,
						express: +bExpress,
					};
				}
				if (locationType === MACHINE_PICKUP) {
					selectedPod = {
						...selectedPod,
						locationType,
						machine: +bMachine,
					};
				}
			}
		}

		darkStores.sort(({ location: location1 = '' }, { location: location2 = '' }) => {
			const loc1 = location1.toLowerCase();
			const loc2 = location2.toLowerCase();
			return loc1.localeCompare(loc2);
		});
		machinePickup.sort(({ location: location1 = '' }, { location: location2 = '' }) => {
			const loc1 = location1.toLowerCase();
			const loc2 = location2.toLowerCase();
			return loc1.localeCompare(loc2);
		});

		const renderedMachines = [...darkStores, ...machinePickup];
		yield all([
			put(selectPod(selectedPod)),
			put(
				fetchPodsSuccess(
					renderedMachines.map(({ location = '', ...rest }) => ({
						...rest,
						location: location.replace(/_/g, ' '),
					}))
				)
			),
		]);
	} catch (error) {
		yield put(fetchPodsError(error));
		yield put(showErrorMsg(error.message));
	}
}

function* fetchPodBanners(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const res = yield call(validateSession, getPodBanners, action.payload, sessionId);
		yield put(fetchPodBannerSuccess(res));
	} catch (error) {
		// yield put(fetchPodBannersError(error));
		// yield put(showErrorMsg(error.message));
	}
}

function* fetchAffiliate(action) {
	try {
		const { mobile, url, navigated = false } = action.payload || {};
		const { sessionId } = yield select((state) => state.auth || {});
		// const coords = yield call(fetchLatlng);
		const res = yield call(validateSession, getAffiliateData, url, mobile, sessionId);
		const { address, area, vm_id, vm_imei_id, location, cart_enabled, ...affiliateData } = res.data || {};
		if (!navigated) {
			affiliateData.time = Date.now();
		}
		yield put(
			fetchAffilateSuccess(
				{ address, area, vm_id, vm_imei_id, location, cart_enabled },
				{ ...(res.data || {}), url: `/affiliate/${url}` }
			)
		);
	} catch (error) {
		yield put(fetchPodsError(error));
		yield put(showErrorMsg(error.message));
	}
}

export function* watchPods() {
	yield takeLatest(FETCH_PODS, fetchPods);
	yield takeLatest(FETCH_POD_BANNERS, fetchPodBanners);
	yield takeLatest(FETCH_AFFILIATE, fetchAffiliate);
}

// const sortPodsViaDistance = (podList = [], userCoords): Array<any> => {
//   return podList.sort((pod1, pod2) => {
//     const pod1Dist = getDistance(userCoords, {latitude: pod1.latitude, longitude: pod1.longitude});
//     const pod2Dist = getDistance(userCoords, {latitude: pod2.latitude, longitude: pod2.longitude});
//     return pod1Dist - pod2Dist;
//   });
// }
